import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const ListBranchPage = loadable(() => import('./ListBranchPage'), {
    fallback: <Loader/>,
});
const AddBranchPage = loadable(() => import('./AddBranchPage'), {
    fallback: <Loader/>,
});
const EditBranchPage = loadable(() => import('./EditBranchPage'), {
    fallback: <Loader/>,
});
const BranchRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListBranchPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddBranchPage t={t} alert={alert} />} />
      <Route exact path='/edit/:id' element={<EditBranchPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
BranchRoute.propTypes = {
  t: PropTypes.func
};
export default BranchRoute;
